import { Injectable, inject } from '@angular/core';
import { Platform } from '@ionic/angular';

const DESKTOP = 'desktop';

@Injectable(    {
    providedIn: 'root',
})
export class PlatformService {
    private platform = inject(Platform);


    isDesktop() {
        return this.platform.is(DESKTOP);
    }
}
